module.exports = __webpack_public_path__ + "img/contenedor4.42a33c5e.png";